import axios from "axios";
import {fromJS} from 'immutable';

const API_ROOT = 'https://api-dev.logunoliktava.lv/data';

/*
This below is the format the middleware accepts.
{
  types: [ACT_LOGIN_PENDING, ACT_LOGIN_SUCCESS, ACT_LOGIN_ERROR],
  url: '/auth/login',
  method: 'post',
  query: {'ajax': true},
  data: {username, password},
  dataType: 'json'
}
*/

export const apiCall = store => next => action => {
    if (typeof action.types === 'undefined' || typeof action.url === 'undefined') return next(action);

    const [pendingType, successType, errorType] = action.types;

    let {
        url,
        method = 'get',
        data = {},
        toDispatch = []
    } = action;

    console.log('Calling api on url: "' + url + '", with intent to ' + method + ' data');

    next({
        type: pendingType,
        payload: '',
    });

    axios({
        url: url,
        method: method,
        baseURL: API_ROOT,
        data: data,
        headers: {
            Authorization: "Bearer " + localStorage.getItem('TOKEN'),
        }
    })
        .then(r => {
                next({
                    type: successType,
                    payload: fromJS(r.data)
                });
                for (let index in toDispatch) {
                    next(toDispatch[index]);
                }
            }
        )
        .catch(function (e) {
                next({
                    type: errorType,
                    payload: fromJS(e)
                })
            }
        );
};